export default "__VITE_ASSET__CYXcia5y__"